define([
    'vue',
    'web/i18n/index',
    'WebCommon/mixin/page',
    'fnjinews2021/component/main',
    'css!vendor/font-awesome/css/font-awesome.min.css',
    'css!WebCommon/css/ub-page-reset.css',
    'css!WebCommon/css/ub-page-grid.css',
    'css!web/static/fonts/fangzheng.css',
    'css!fnjinews2021/component/main.css'

], function(
    Vue,
    i18n,
    PageMixin,

    MainPage
){

    var app = new Vue({
        mixins: [PageMixin],
        components: {
            MainPage: MainPage
        },
        i18n: i18n
    });
    app.$mount('#app');


});


//////////////////
// WEBPACK FOOTER
// ./fnjinews2021/fnjinews2021.js
// module id = 114
// module chunks = 0